export const checkDisabled = (items) => {
  return items.some((item) => !item?.enabled);
};
